import { Box, Skeleton, Stack } from "@mui/material";

// Placeholders for `AsyncState`'s `loadingFallback`, in the three shapes the admin pages load
// into. They are decoration: the loading text is announced by `AsyncState` itself, so each one
// is hidden from the accessibility tree.

interface SkeletonCardsProps {
	count?: number;
	/** Height of one card, in px. Match the page's real card so the layout does not jump. */
	height?: number;
}

/** A single column of cards: a job list, a phone layout. */
export function SkeletonCardList({ count = 4, height = 96 }: SkeletonCardsProps) {
	return (
		<Stack aria-hidden spacing={1}>
			{Array.from({ length: count }, (_, index) => (
				<Skeleton key={index} variant="rounded" height={height} />
			))}
		</Stack>
	);
}

/** Cards that wrap into as many 280px-minimum columns as fit. */
export function SkeletonCardGrid({ count = 6, height = 160 }: SkeletonCardsProps) {
	return (
		<Box aria-hidden sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 2 }}>
			{Array.from({ length: count }, (_, index) => (
				<Skeleton key={index} variant="rounded" height={height} />
			))}
		</Box>
	);
}

/** A header band and rows, for a page that loads into a table. */
export function SkeletonTable({ rows = 8 }: { rows?: number }) {
	return (
		<Stack aria-hidden spacing={0.5}>
			<Skeleton variant="rounded" height={40} />
			{Array.from({ length: rows }, (_, index) => (
				<Skeleton key={index} variant="rounded" height={52} />
			))}
		</Stack>
	);
}
